/* eslint-disable */

import React, { useReducer, useMemo, useEffect } from 'react';
import { logsAuditory, setLoadAuditory, sliceLogs } from './actions';

import {
  initialState,
  auditoryReducer,
  AuditoryContext,
  outAuditory,
} from './feature';
import RegisterSelector from '../component/RegisterSelector';
import RegisterCrashlytics from '../component/RegisterCrashlytics';
import ErrorBoundary from '../component/ErrorBoundary';

export const AuditoryProvider = ({ children, fallback }) => {
  const [state, dispatch] = useReducer(auditoryReducer, initialState);

  outAuditory.state = state;
  outAuditory.dispatch = (payload) => dispatch(payload);

  const value = useMemo(
    () => ({ state: initialState, dispatch }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state.autoLoad]
  );

  useEffect(() => {
    if (!state.isLoading && state.auditoria.numeroDocumento !== '') {
      const logs = [...state.logs];
      const log = logs.shift();

      if (state.logs.length > 0) {
        if (!state.auditoria.idAuditoria) {
          setLoadAuditory(dispatch);
        }
        sliceLogs(dispatch, logs);
        logsAuditory(dispatch, state.auditoria, log);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isLoading, state.auditoria.idAuditoria, state.logs]);

  return (
    <AuditoryContext.Provider value={value}>
      <RegisterSelector outAuditory={outAuditory} />
      <RegisterCrashlytics />
      <ErrorBoundary fallback={fallback}>
        {children}
      </ErrorBoundary>
    </AuditoryContext.Provider>
  );
};
